export default __webpack_public_path__ + "static/media/05.3123a92e.jpg";